import { useSettings } from '@wix/tpa-settings/react';
import type { FC } from 'react';
import React from 'react';

import settingsParams from '../../../settingsParams';
import SectionTitle from '../../common/SectionTitle';
import { classes } from './Title.st.css';

interface TitleProps {
  postCount: number;
}

export const Title: FC<TitleProps> = ({ postCount }) => {
  const settings = useSettings();

  const showPostCount = postCount > 0;

  const htmlTag = settings.get(settingsParams.blogPostsTitleHtmlTag);

  return (
    <div className={classes.root}>
      <SectionTitle htmlTag={htmlTag}>
        {settings.get(settingsParams.blogPostsTitle)}
        {showPostCount ? (
          <span className={classes.postCount}>{` (${postCount})`}</span>
        ) : null}
      </SectionTitle>
    </div>
  );
};
